// Msal imports
import { MsalAuthenticationTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { apiConfig, loginRequest } from "../../authConfig";

// imports
import { Loading } from "../../components/Loading";
import { ErrorComponent } from "../../components/ErrorComponent";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../utils/GlobalContext";
import { CredentialsContext } from "./CredentialsContext";

import ProtectedComponent from "../../utils/ProtectedComponent";
import ProtectedPage from "../../utils/ProtectedPage";
import { Client } from "../../utils/Definitions";
import Select, { MultiValue, OnChangeValue } from "react-select";
import { ChoiceOption} from '../../utils/Definitions';
import { ValueContainer } from "../../components/ValueContainer";





//only renders if authenticated
const PhysicianOrderExpContent = () => {

    const globalContext = useContext(GlobalContext);
    const credentialsContext = useContext(CredentialsContext);

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const [clients, setClients] = useState<Client[] | null>([]);
    const [centers, setCenters] = useState<ChoiceOption[]>([]);

    useEffect(() => {
        UpdateClients();
    }, []);


    function UpdateClients() {

        globalContext.GetToken().then((token: any) => {
            setLoading(true);
            var headers = new Headers();

            var bearer = "Bearer " + token;

            headers.append("Authorization", bearer);
            var options = {
                method: "GET",
                headers: headers
            };

            fetch(apiConfig.apiEndpoint + "/Clients/GetAllClientsPhysicianOrderExp", options)
                .then(res => res.json())
                .then(
                    (result) => {
                        console.log("GetAllClientsPhysicianOrderExp:", result);
                        setClients(result);
                        setLoading(false);
                    },
                    (error) => {
                        setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetAllClientsPhysicianOrderExp" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    const filteredClients =
        (centers.length > 0
            ? clients?.filter(c => centers.some(center => Number(center.value) === Number(c.centerId)))
            : clients
        )?.sort((a, b) => {
            const dateA = a.physicianOrderExpDate ? new Date(a.physicianOrderExpDate).getTime() : 0;
            const dateB = b.physicianOrderExpDate ? new Date(b.physicianOrderExpDate).getTime() : 0;
            return dateA - dateB; // descending
        });



    if (loading) {
        return <Loading />;
    }

    return (
        <div className="flex-1 p-5 flex flex-col items-center">
            <h2 className="text-xl font-semibold mb-4">Physician Orders Expiring Soon</h2>

            <div className="flex flex-col w-full xl:w-[24rem]">
                <label className="text-sm font-medium text-gray-700 mb-1">
                    Filter by centers:
                </label>
                <div className="flex justify-center">
                    <Select
                        isMulti={true}
                        closeMenuOnSelect={false}
                        blurInputOnSelect={false}
                        components={{ ValueContainer }}
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                            valueContainer: base => ({ ...base, height: '30px' })
                        }}
                        className="w-full"
                        hideSelectedOptions={false}
                        options={globalContext.centerChoices ?? undefined}
                        onChange={selectedOptions => setCenters([...(selectedOptions ?? [])])}
                        value={centers}
                    />
                </div>
            </div>



            {filteredClients == null || filteredClients.length === 0 ? (
                <p className="text-gray-600 mt-4">No clients have physician orders expiring within 60 days.</p>
            ) : (
                <div className="overflow-x-auto w-full max-w-3xl mt-4">
                    <table className="table-auto border border-gray-300 rounded-lg shadow-sm mx-auto">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700 border-b">Learner</th>
                                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700 border-b">Center</th>
                                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700 border-b">Date Of Exp</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredClients.map((client: Client, index: number) => {
                                const isExpired =
                                    client.physicianOrderExpDate &&
                                    new Date(client.physicianOrderExpDate) < new Date();

                                return (
                                    <tr
                                        key={index}
                                        className={(isExpired ? "bg-red-100 hover:bg-red-200" : "hover:bg-gray-100")}
                                    >
                                        <td className="px-4 py-2 border-b text-sm text-gray-800">{client.fullName}</td>
                                        <td className="px-4 py-2 border-b text-sm text-gray-800">{client.centerName}</td>
                                        <td
                                            className={`px-4 py-2 border-b text-sm ${isExpired ? "text-red-800 font-semibold" : "text-gray-800"
                                                }`}
                                        >
                                            {client.physicianOrderExpDate
                                                ? new Date(client.physicianOrderExpDate).toLocaleDateString()
                                                : "—"}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>



    );
};



export function PhysicianOrderExp() {
    const authRequest = {
        ...loginRequest
    };

    return (
        <>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest} errorComponent={ErrorComponent} loadingComponent={Loading}>
                <ProtectedPage RequiredRoles={['Administration.Learner.Write']}>
                    <PhysicianOrderExpContent />
                </ProtectedPage>
            </MsalAuthenticationTemplate>

            <UnauthenticatedTemplate>

            </UnauthenticatedTemplate>
        </>
    )
};